import {
  Banner,
  type BannerAsideProps,
  type BannerBackgroundProps,
  type BannerContentProps,
  type BannerHeaderProps,
  type BannerProps,
} from "@webmotors/eleanor-ui";

export function BannerDS({ children, ...props }: Readonly<BannerProps>) {
  return <Banner {...props}>{children}</Banner>;
}

function BannerDSBackground({
  children,
  ...props
}: Readonly<BannerBackgroundProps>) {
  return <Banner.Background {...props}>{children}</Banner.Background>;
}

function BannerDSContent({ children, ...props }: Readonly<BannerContentProps>) {
  return <Banner.Content {...props}>{children}</Banner.Content>;
}

function BannerDSHeader({ ...props }: Readonly<BannerHeaderProps>) {
  return <Banner.Header {...props} />;
}

function BannerDSAside({ children, ...props }: Readonly<BannerAsideProps>) {
  return <Banner.Aside {...props}>{children}</Banner.Aside>;
}

export namespace BannerDS {
  export const Background = BannerDSBackground;
  export const Content = BannerDSContent;
  export const Header = BannerDSHeader;
  export const Aside = BannerDSAside;
}
